import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  CardHeader,
  Table,
  Badge,
  Spinner,
  ListGroup,
  ListGroupItem,
  FormGroup,
  Label,
  Input,
  InputGroup,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams } from "react-router";
import { useContext, useEffect, useState } from "react";
import EnterpriseService from "../../common/services/enterprise-service";
import LoadingOverlay from "react-loading-overlay";
import { EnterpriseContext } from "./EnterpriseContext";
import Tips from "../Tips";
import { toast, ToastContainer } from "react-toastify";
import EnterpriseNavBar from "./EnterpriseNavBar";
import { faExchange } from "@fortawesome/free-solid-svg-icons";
import CustomBadge from "../ui/CustomBadge";
import UserDefinedUnits from "../../common/utils/UserDefinedUnits";
import BoxDynamicAd from "../../ads/BoxDynamicAd";
import truckyService from "../../common/services/trucky-service";
import VTCMenu from "../../web/components/VTCMenu";
import Breadcrumbs from "../../web/components/Breadcrumbs";
import reactSelectCustomStyles from "../../common/plugins/reactSelectStyles";
import Select from "react-select";
import ReactSelectUserOption from "../ui/ReactSelectUserOption";
import VehiclePlate from "./VehiclePlate";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { confirmWrapper } from "../ui/askConfirm";
import MaintenanceAlerts from "./MaintenanceAlerts";

const VehicleDetail = ({ container }) => {
  const { globalContext } = useContext(EnterpriseContext);

  const company = globalContext.company;
  const member = globalContext.member;

  const [vehicle, setVehicle] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const es = new EnterpriseService();
  const [garages, setGarages] = useState([]);
  const [members, setMembers] = useState([]);
  const [mechanics, setMechanics] = useState([]);
  const [mechanic, setMechanic] = useState(0);
  const [membersIsLoading, setMembersIsLoading] = useState(false);

  useEffect(() => {
    truckyService.setDocumentTitle("Vehicle Details");
  }, []);

  useEffect(() => {
    getVehicle();

    if (es.can(member, "vehicles.assign")) {
      getGarages();
      getMembers();
    }
  }, []);

  const getMechanics = async (vehicle) => {
    const result = await es.getGarageMechanics(company.id, vehicle.garage.id);
    setMechanics(result.filter((m) => m.skill == vehicle.maintenance_needed));
  };

  const getVehicle = async () => {
    setLoading(true);
    const result = await es.getVehicle(company, id);
    setVehicle(result);

    if (
      es.can(member, "garages.maintenances") &&
      result != null &&
      result.status == "need_maintenance"
    ) {
      getMechanics(result);
    }

    setLoading(false);
  };

  const getMembers = async () => {
    setMembersIsLoading(true);
    const result = await es.getMembers(company, {
      perPage: 9999,
    });
    setMembers(result.data);
    setMembersIsLoading(false);
  };

  const getGarages = async () => {
    const result = await es.getGarages(company);
    setGarages(result);
  };

  const submitEdit = async () => {
    const result = await es.updateVehicle(company, vehicle);
    if (result.success) {
      getVehicle();
      toast.success(container.localeManager.strings.vehicleUpdated);
    } else {
      toast.error(result.message);
    }
  };

  const getStatus = () => {
    if (vehicle.status == "active") {
      return (
        <CustomBadge color="success">
          <FontAwesomeIcon icon="check"></FontAwesomeIcon>
          {container.localeManager.strings.active}
        </CustomBadge>
      );
    }
    if (vehicle.status == "under_maintenance") {
      const maintenanceEnd = container.localeManager
        .moment(vehicle.maintenance_end_date)
        .local()
        .format("LLL");
      return (
        <>
          <CustomBadge color="danger">
            <FontAwesomeIcon icon="wrench"></FontAwesomeIcon>
            {container.localeManager.strings.under_maintenance} -{" "}
            {maintenanceEnd}
          </CustomBadge>
        </>
      );
    }
    if (vehicle.status == "need_maintenance") {
      return (
        <>
          <CustomBadge color="warning">
            <FontAwesomeIcon icon="wrench"></FontAwesomeIcon>
            {container.localeManager.strings.need_maintenance} -{" "}
            {container.localeManager.strings[vehicle.maintenance_needed]}
          </CustomBadge>
        </>
      );
    }
  };

  const startMaintenance = async () => {
    setLoading(true);
    const result = await es.assignVehicleToMechanic(company, {
      mechanic_id: mechanic,
      vehicle_id: vehicle.id,
      maintenance_type: vehicle.maintenance_needed,
    });
    if (result.success) {
      toast.success(container.localeManager.strings.maintenanceStarted);
    } else {
      toast.error(result.message);
    }
    getVehicle();
  };

  function getProgressBar(nextMaintenanceKm) {
    // Calculate the percentage
    let percentage = (vehicle.odometer_km / nextMaintenanceKm) * 100;

    let className = "bg-secondary";

    if (percentage > 80) {
      className = "bg-danger";
    } else if (percentage > 60) {
      className = "bg-warning";
    } else if (percentage > 40) {
      className = "bg-info";
    } else {
      className = "bg-success";
    }

    // Round to 2 decimal places
    return (
      <div class="position-relative mt-3">
        <div class="progress">
          <div
            className={`progress-bar progress-bar-animated ${className}`}
            role="progressbar"
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
        <div class="progress-bar-text mt-2">
          <div className="d-flex justify-content-between">
            <span></span>
            <span>
              {UserDefinedUnits.convertDistance(
                member,
                vehicle.game.id,
                nextMaintenanceKm
              )}
            </span>
          </div>
        </div>
      </div>
    );
  }

  const getProgressBarUnfixable = (percentage) => {
    return (
      <div class="position-relative mt-3">
        <div class="progress">
          <div
            className={`progress-bar ${percentage}`}
            role="progressbar"
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
        <div class="progress-bar-text mt-2">
          {container.localeManager.numeral(percentage).format("0,0")}%
        </div>
      </div>
    );
  };

  const replacePart = async (part) => {
    if (
      await confirmWrapper(container.localeManager.strings.areYouSure, {
        container: container,
      })
    ) {
      const result = await es.replacePart(company, vehicle, part);
      if (result.success) {
        toast.success(container.localeManager.strings.maintenaceStarted);
        getVehicle();
      } else {
        toast.error(result.message);
      }
    }
  };

  const getUnfixableWearElement = (prop) => {
    return (
      <div className="grid cols-4">
        <div className="d-flex align-items-center">
          {container.localeManager.strings[prop]}
        </div>
        <div className="d-flex align-items-center">
          {vehicle.parts_to_replace &&
            vehicle.parts_to_replace.includes(prop) && (
              <>
                <FontAwesomeIcon
                  icon="exclamation-triangle"
                  className="text-danger me-2"
                ></FontAwesomeIcon>
                <span className="text-danger">
                  {container.localeManager.strings.replacePart}
                </span>
              </>
            )}
        </div>
        <div className="d-flex">
          <div className="w-300px me-5">
            {getProgressBarUnfixable(vehicle[`unfixable_${prop}_wear`])}
          </div>
        </div>
        {es.can(member, "garages.maintenances") && (
          <div className="d-flex justify-content-end">
            <Button
              title={container.localeManager.strings.replacePart}
              size="sm"
              className="border border-danger border-dashed w-100"
              color="active-light-success"
              onClick={() => replacePart(prop)}
              disabled={
                vehicle.status != 'need_maintenance' || vehicle[`unfixable_${prop}_wear`] < 10
              }
            >
              <FontAwesomeIcon icon="screwdriver-wrench"></FontAwesomeIcon>
              {container.localeManager
                .numeral(vehicle.component_replacement_costs[prop])
                .format("0,0")}{" "}
              T¢
            </Button>
          </div>
        )}
      </div>
    );
  };

  const sell = async () => {
    if (
      await confirmWrapper(container.localeManager.strings.sellVehicleConf, {
        container: container,
      })
    ) {
      setLoading(true);
      const result = await es.deleteVehicle(company, vehicle);
      if (result.success) {
        toast.success(container.localeManager.strings.vehicleSold);
        navigate("/vehicles");
      } else {
        toast.error(result.message);
      }
      setLoading(false);
    }
  };

  return (
    <LoadingOverlay
      active={loading}
      spinner={
        <Spinner
          color="primary"
          style={{ width: "4rem", height: "4rem" }}
        ></Spinner>
      }
    >
      <Row noGutters className="">
        <VTCMenu active={"/vehicles"} container={container}></VTCMenu>

        <Col>
          <Row noGutters>
            <Col>
              <Card className="h-100">
                <CardBody>
                  <Breadcrumbs
                    breadcrumbs={[
                      {
                        to: "/vtchub",
                        title: container.localeManager.strings.vtcHub,
                      },
                      {
                        to: "/vehicles",
                        title: container.localeManager.strings.fleet,
                      },
                      {
                        title: container.localeManager.strings.vehicle,
                      },
                    ]}
                  ></Breadcrumbs>
                  {vehicle != null && (
                    <>
                      <Card className="text-center mb-3 bg-secondary">
                        <CardBody>
                          <div className="d-flex align-items-center justify-content-center justify-content-between">
                            <img
                              style={{ width: 150 }}
                              src={vehicle.model.brand.logo_url}
                              className="me-3"
                            />
                            <div className="d-flex flex-column align-items-center justify-content-center">
                              <div class="fs-1 mb-3">
                                #{vehicle.id} - {vehicle.vehicle_name}
                              </div>

                              <VehiclePlate
                                container={container}
                                vehicle={vehicle}
                              ></VehiclePlate>
                              <div className="mt-3">{getStatus()}</div>
                            </div>
                            <img
                              style={{ width: 200 }}
                              src={vehicle.model.photo_url}
                            />
                          </div>
                        </CardBody>
                      </Card>
                      <Row>
                        {es.can(member, "vehicles.assign") && (
                          <Col>
                            <FormGroup>
                              <Label>
                                {container.localeManager.strings.fleetNumber}
                              </Label>
                              <Input
                                onChange={(e) =>
                                  setVehicle({
                                    ...vehicle,
                                    edited: true,
                                    fleet_number: e.target.value,
                                  })
                                }
                                value={vehicle.fleet_number}
                                maxLength={6}
                              ></Input>
                            </FormGroup>
                            {garages.length > 0 && (
                              <>
                                <FormGroup>
                                  <Label sm="auto">
                                    {
                                      container.localeManager.strings
                                        .moveToGarage
                                    }
                                  </Label>
                                  <Input
                                    value={vehicle.garage_id}
                                    type="select"
                                    onChange={(e) =>
                                      setVehicle({
                                        ...vehicle,
                                        edited: true,
                                        garage_id: e.target.value,
                                      })
                                    }
                                  >
                                    {garages.map((g) => {
                                      return (
                                        <option value={g.id}>
                                          {g.city.name}
                                        </option>
                                      );
                                    })}
                                  </Input>
                                </FormGroup>
                                <FormGroup>
                                  <Label sm="auto">
                                    {
                                      container.localeManager.strings
                                        .assignToUser
                                    }
                                  </Label>
                                  <Select
                                    styles={reactSelectCustomStyles}
                                    value={
                                      members.find(
                                        (m) =>
                                          m.id === vehicle.assigned_to_user_id
                                      ) || null
                                    }
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    options={members}
                                    isClearable={true}
                                    onChange={(e) =>
                                      setVehicle({
                                        ...vehicle,
                                        edited: true,
                                        assigned_to_user_id: e ? e.id : null,
                                      })
                                    }
                                    isLoading={membersIsLoading}
                                    components={{
                                      Option: ReactSelectUserOption,
                                    }}
                                  ></Select>
                                </FormGroup>
                                <FormGroup>
                                  <Button
                                    size="sm"
                                    onClick={submitEdit}
                                    color="success"
                                  >
                                    <FontAwesomeIcon icon="check" />
                                    {container.localeManager.strings.save}
                                  </Button>
                                  {es.can(member, "vehicles.sell") && (
                                    <Button
                                      size="sm"
                                      onClick={sell}
                                      color="danger"
                                      className="ms-3"
                                    >
                                      <FontAwesomeIcon icon="times" />
                                      {container.localeManager.strings.sell}
                                    </Button>
                                  )}
                                </FormGroup>
                              </>
                            )}
                          </Col>
                        )}
                      </Row>
                      {es.can(member, "garages.maintenances") &&
                        vehicle.status == "need_maintenance" && (
                          <div className="mt-3">
                            <FormGroup row>
                              <Label sm="auto">
                                {container.localeManager.strings.mechanics}
                              </Label>
                              <Col sm={6}>
                                <Input
                                  onChange={(e) => setMechanic(e.target.value)}
                                  type="select"
                                >
                                  <option value="0">
                                    {
                                      container.localeManager.strings
                                        .assignVehicleMechanic
                                    }
                                  </option>
                                  {mechanics.map((m) => {
                                    return (
                                      <option
                                        disabled={m.vehicle_id != null}
                                        value={m.id}
                                      >
                                        {m.name} -{" "}
                                        {container.localeManager.strings.speed}:{" "}
                                        {m.speed}
                                      </option>
                                    );
                                  })}
                                </Input>
                              </Col>
                              <Col sm="auto">
                                <Button
                                  disabled={mechanic == 0}
                                  size="sm"
                                  onClick={startMaintenance}
                                  color="warning"
                                >
                                  {
                                    container.localeManager.strings
                                      .startMaintenance
                                  }
                                </Button>
                              </Col>
                            </FormGroup>
                          </div>
                        )}
                      <div className="grid cols-2 no-gap mt-3 cards-h-no-style">
                        <Card className="text-center">
                          <CardHeader>
                            {container.localeManager.strings.driver}
                          </CardHeader>
                          <CardBody className="d-flex align-items-center justify-content-center">
                            {vehicle.driver != null && (
                              <>
                                <div className="text-center d-flex align-items-center">
                                  <div>
                                    <img
                                      src={vehicle.driver.avatar_url}
                                      className="avatar rounded h-50px min-w-50px me-3"
                                    />
                                  </div>
                                  <div>
                                    <Link to={`/user/${vehicle.driver.id}`}>
                                      {vehicle.driver.name}
                                    </Link>
                                  </div>
                                </div>
                              </>
                            )}
                            {vehicle.driver == null && (
                              <h5>
                                {container.localeManager.strings.notAssigned}
                              </h5>
                            )}
                          </CardBody>
                        </Card>
                        <Card className="text-center">
                          <CardHeader>
                            {container.localeManager.strings.garage}
                          </CardHeader>
                          <CardBody className="d-flex align-items-center justify-content-center">
                            <h5>
                              <Link to={`/garage/${vehicle.garage.id}`}>
                                {vehicle.garage.city.name} (
                                {vehicle.garage.vehicles_count} /{" "}
                                {vehicle.garage.max_vehicles})
                              </Link>
                            </h5>
                          </CardBody>
                        </Card>
                      </div>
                      <div className="grid cols-3 no-gap cards-h-no-style">
                        <Card className="text-center">
                          <CardHeader>
                            {container.localeManager.strings.odometer}
                          </CardHeader>
                          <CardBody className="d-flex align-items-center justify-content-center">
                            <h5>
                              {UserDefinedUnits.convertDistance(
                                member,
                                null,
                                vehicle.odometer_km
                              )}
                            </h5>
                          </CardBody>
                        </Card>
                        <Card className="text-center">
                          <CardHeader>
                            {container.localeManager.strings.price}
                          </CardHeader>
                          <CardBody className="d-flex align-items-center justify-content-center">
                            <h5>
                              {vehicle.used_purchase_price != null && (
                                <>
                                  <strike>
                                    {container.localeManager
                                      .numeral(vehicle.price)
                                      .format("0,0")}{" "}
                                    {vehicle.company.currency}
                                  </strike>
                                  <span className="ms-2">
                                    {container.localeManager
                                      .numeral(vehicle.used_purchase_price)
                                      .format("0,0")}{" "}
                                    {vehicle.company.currency}
                                  </span>
                                </>
                              )}
                              {vehicle.used_purchase_price == null && (
                                <span>
                                  {container.localeManager
                                    .numeral(vehicle.price)
                                    .format("0,0")}{" "}
                                  {vehicle.company.currency}
                                </span>
                              )}
                            </h5>
                          </CardBody>
                        </Card>
                        <Card className="text-center">
                          <CardHeader>
                            {container.localeManager.strings.boughtOn}
                          </CardHeader>
                          <CardBody className="d-flex align-items-center justify-content-center">
                            <h5>
                              {container.localeManager
                                .moment(vehicle.created_at)
                                .format("l")}
                            </h5>
                          </CardBody>
                        </Card>
                      </div>
                      <div>
                        <Card>
                          <CardHeader>
                            {container.localeManager.strings.unfixableDamage}
                          </CardHeader>
                          <CardBody>
                            {getUnfixableWearElement("engine")}
                            {getUnfixableWearElement("transmission")}
                            {getUnfixableWearElement("brakes")}
                            {getUnfixableWearElement("electronics")}
                          </CardBody>
                        </Card>
                      </div>
                      <div className="grid cols-2 no-gap">
                        <Card>
                          <CardHeader>
                            {container.localeManager.strings.statistics}
                          </CardHeader>
                          <CardBody>
                            <ListGroup flush>
                              <ListGroupItem>
                                {container.localeManager.strings.revenue}
                                <span className="float-end">
                                  {container.localeManager
                                    .numeral(vehicle.total_revenue)
                                    .format("0,0")}{" "}
                                  {vehicle.company.currency}
                                </span>
                              </ListGroupItem>
                              <ListGroupItem>
                                {container.localeManager.strings.fuelUsed}
                                <span className="float-end">
                                  {UserDefinedUnits.convertVolume(
                                    member,
                                    null,
                                    vehicle.total_fuel_used_l
                                  )}
                                </span>
                              </ListGroupItem>
                              <ListGroupItem>
                                {container.localeManager.strings.damageCost}
                                <span className="float-end">
                                  {container.localeManager
                                    .numeral(vehicle.total_damage_cost)
                                    .format("0,0")}{" "}
                                  {vehicle.company.currency}
                                </span>
                              </ListGroupItem>
                            </ListGroup>
                          </CardBody>
                        </Card>
                        <Card>
                          <CardHeader>
                            {container.localeManager.strings.nextMaintenance}
                          </CardHeader>
                          <CardBody>
                            <ListGroup flush>
                              <ListGroupItem>
                                {container.localeManager.strings.general}
                                {getProgressBar(
                                  vehicle.next_maintenance.general
                                )}
                              </ListGroupItem>
                              <ListGroupItem>
                                {container.localeManager.strings.tires}
                                {getProgressBar(vehicle.next_maintenance.tires)}
                              </ListGroupItem>
                              <ListGroupItem>
                                {container.localeManager.strings.engine}

                                {getProgressBar(
                                  vehicle.next_maintenance.engine
                                )}
                              </ListGroupItem>
                            </ListGroup>
                          </CardBody>
                        </Card>
                      </div>
                      <Row>
                        <Col>
                          {vehicle.maintenances &&
                            vehicle.maintenances.length > 0 && (
                              <>
                                <h5 className="mt-3">
                                  {
                                    container.localeManager.strings
                                      .maintenanceEvents
                                  }
                                </h5>
                                <Table
                                  responsive
                                  striped
                                  size="sm"
                                  className="table-row-dashed table-row-gray-300 align-middle gs-0"
                                  hover
                                >
                                  <thead>
                                    <tr className="fw-bolder text-gray-700 bg-light">
                                      <th scope="col" className="ps-4">
                                        {container.localeManager.strings.date}
                                      </th>
                                      <th scope="col">
                                        {container.localeManager.strings.type}
                                      </th>
                                      <th scope="col">
                                        {container.localeManager.strings.price}
                                      </th>
                                      <th scope="col">
                                        {
                                          container.localeManager.strings
                                            .odometer
                                        }
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {vehicle.maintenances.map((m) => {
                                      return (
                                        <tr>
                                          <td className="ps-2">
                                            {container.localeManager
                                              .moment(m.created_at)
                                              .format("l")}
                                          </td>
                                          <td>
                                            {
                                              container.localeManager.strings[
                                                m.type
                                              ]
                                            }
                                          </td>
                                          <td>
                                            {container.localeManager
                                              .numeral(m.price)
                                              .format("0,0")}{" "}
                                            {m.currency}
                                          </td>
                                          <td>
                                            {UserDefinedUnits.convertDistance(
                                              member,
                                              null,
                                              m.odometer_km
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                              </>
                            )}
                        </Col>
                      </Row>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
            <aside className="ad-column-placeholder">
              <Tips localeManager={container.localeManager}></Tips>
              <MaintenanceAlerts
                container={container}
                company={company}
              ></MaintenanceAlerts>
              {!window.overwolf && (
                <BoxDynamicAd container={container} className="my-3" />
              )}
            </aside>
          </Row>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Col>
      </Row>
    </LoadingOverlay>
  );
};

export default VehicleDetail;
